import { z } from "zod";

const passwordSchema = z
  .string()
  .min(8, { error: "Password must be at least 8 characters" });

export const signinSchema = z.object({
  email: z.email({ error: "Invalid email address" }),
  password: z
    .string()
    .min(6, { error: "Password must be at least 6 characters" }),
});

export const signupSchema = z.object({
  email: z.email({ error: "Invalid email address" }),
  password: passwordSchema,
});

export type SigninFormData = z.infer<typeof signinSchema>;
export type SignupFormData = z.infer<typeof signupSchema>;
